import { useSyncExternalStore } from 'react';

import { getDateFormat, subscribeDateFormat } from '../utils/dateDisplay';

/**
 * Subscribes the component to the app-wide date display format. Call it in
 * any component that renders dates via the dateDisplay/formatters helpers so
 * a preference change re-renders it immediately; the return value is the
 * current format string (also readable non-reactively via getDateFormat()).
 */
export default function useDateFormat() {
	return useSyncExternalStore(subscribeDateFormat, getDateFormat, getDateFormat);
}
